import feathersClient, { makeServicePlugin, BaseModel } from '../../feathers-client'

class CategoryTranslationMedia extends BaseModel {
  // Required for $FeathersVuex plugin to work after production transpile.

  static modelName = 'CategoryTranslationMedia'
  // Define default properties here
  static instanceDefaults () {
    return {
      mediaId: null,
      categoryTranslationId: null,
    }
  }
}
const servicePath = 'categories-translations-media'
const servicePlugin = makeServicePlugin({
  Model: CategoryTranslationMedia,
  service: feathersClient.service(servicePath),
  servicePath,
})

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
})

export default servicePlugin
